export default "__VITE_ASSET__CQ1$Gt3Y__"